const WildixEvents = {
    CHAT_RECEIVER: 'wildix/chatreceived',
    SHOW_NOTIFICATION: 'wildix/show_notification',
    OPEN_DIALOG: 'wildix/open_dialog',
    HIDE_DIALOG: 'wildix/hide_dialog',
    PARTICIPANT_JOINED: 'wildix/participant_joined',
    PARTICIPANT_LEFT: 'wildix/participant_left',
    CONFERENCE_LOADED: 'conferenceLoaded',
    CONFERENCE_JOINED: 'conferenceJoined',
    CONFERENCE_HUNGUP: 'conferenceHungup',
    CONFERENCE_DISPOSE: 'disposeConference',
    CONNECTION_ERROR: 'connectionError',
    SHOW_TUTORIAL: 'showTutorial',
    DIALOG_TUTORIAL_OPENED: 'dialogTutorialOpened',
    SHOW_NOTIFICATION_NO_AUDIO: 'SHOW_NOTIFICATION_NO_AUDIO'
};
export default WildixEvents;
